<div class="no-result-container">
  @if (showImage) {
  <img src="assets/images/tqr-icon.svg" alt="TQR Logo" class="no-result-logo" />
  }

  <h2 class="no-result-title">{{ title | translate }}</h2>

  <p class="no-result-subtitle">{{ subtitle | translate }}</p>

  @if (showReloadHint) {
  <p class="no-result-hint">
    {{ "events.empty.reload" | translate }}
  </p>
  }
</div>
